<div mat-dialog-content>
  <h3>{{formData.title}}</h3>
  {{ formData.message }}
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close]="true" cdkFocusInitial color="primary" mat-button
          mat-stroked-button>{{confirmButtonText}}</button>
  <button (click)="onNoClick()" color="warn" mat-button mat-stroked-button>{{cancelButtonText}}</button>
</div>
